"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isRtl = void 0;

var isRtl = function isRtl() {
  return document.documentElement.getAttribute('dir') === 'rtl';
};

exports.isRtl = isRtl;
var _default = isRtl;
exports.default = _default;